import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  fiat: {
    id: 'donater.payment_type.fiat.title',
    defaultMessage: 'Fiat',
  },
  loading: {
    id: 'donater.payment_type.fiat.loading_methods',
    defaultMessage: 'Looking for the best payment methods for you...',
  },
})
